export default {
    token: '',
    error: false,
    errorMessage: ''
}